/** @format */
import {useReducer} from 'react';
import {useRouter} from 'next/router';

import SeoMeta from '@components/common/seo';
import Index from '@components/brands';
// reducer methods
import {init, reducer} from '@reducers/brands/brands';
function Brands() {
	const router = useRouter();
	const [state, dispatch] = useReducer(reducer, init);

	return (
		<>
			<SeoMeta
				title={`${state.name} | Shop hundreds of brands online at Food For Change`}
				url={state.activeCategory}
				description={`${state.name} | Explore the latest brands Birkenstock, RW Williams, Tolu Australia & more and give back with every purchase at Betterthat.com`}
				keywords={`Buy ${state.name} online`}
			/>
			<Index router={router} state={state} dispatch={dispatch}></Index>;
		</>
	);
}

Brands.Layout = true;

export default Brands;
